var map = {
	"./black-coordinator.png": "f3de",
	"./black-donator.png": "dd6b",
	"./black-indicator.png": "e1cc",
	"./black-master.png": "e5e1",
	"./bronze-coordinator.png": "d421",
	"./bronze-donator.png": "d254",
	"./bronze-indicator.png": "4a40",
	"./bronze-master.png": "c212",
	"./diamond-coordinator.png": "a8a7",
	"./diamond-donator.png": "f316",
	"./diamond-indicator.png": "f6d0",
	"./diamond-master.png": "2391",
	"./gold-coordinator.png": "bb47",
	"./gold-donator.png": "91a6",
	"./gold-indicator.png": "ef0c",
	"./gold-master.png": "31fd",
	"./silver-coordinator.png": "10ef",
	"./silver-donator.png": "d175",
	"./silver-indicator.png": "f318",
	"./silver-master.png": "81ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a70";